import { MakeClinicalDoc as UsecaseReduxMakeClinicalDoc } from '~/domain/usecases/clinicalDocs/redux';

import { ReduxMakeClinicalDoc } from '~/data/store/reducer/clinicalDocs/usecases';

export const makeReduxMakeClinicalDoc = (): UsecaseReduxMakeClinicalDoc =>
  new ReduxMakeClinicalDoc();
